export const extraPalettes = { useful: [
  
  {
    id: "k4fsyb",
    name: "Sticky Colors",
    _colors: [
      {
        color: "#f5f6f8",
        id: "ez89to",
      },
      {
        color: "#fff9b1",
        id: "e5a3nc",
      },
      {
        color: "#f5d128",
        id: "gywzc1",
      },
      {
        color: "#ff9d48",
        id: "8lf76d",
      },
      {
        color: "#d5f692",
        id: "7r88ag",
      },
      {
        color: "#c9df56",
        id: "3d7onx",
      },
      {
        color: "#93d275",
        id: "n6rwz1",
      },
      {
        color: "#67c6c0",
        id: "qrdqcm",
      },
      {
        color: "#ffcee0",
        id: "g60uuj",
      },
      {
        color: "#ea94bb",
        id: "8fpb9y",
      },
      {
        color: "#be88c7",
        id: "jo3zu7",
      },
      {
        color: "#f16c7f",
        id: "de9b9d",
      },
      {
        color: "#a6ccf5",
        id: "j2z2jr",
      },
      {
        color: "#6cd8fa",
        id: "49v8b3",
      },
      {
        color: "#7b92ff",
        id: "hlhel5",
      },
      {
        color: "#000000",
        id: "j1m8df",
      },
    ],
  },
  {
    id: "wt2mdo",
    name: "Tag Colors",
    _colors: [
      {
        color: "#f24726",
        id: "b7w4au",
      },
      {
        color: "#da0063",
        id: "waesvl",
      },
      {
        color: "#9410ab",
        id: "77g28p",
      },
      {
        color: "#cee741",
        id: "2c56ti",
      },
      {
        color: "#8fd14f",
        id: "9229n9",
      },
      {
        color: "#0ca789",
        id: "47hcsh",
      },
      {
        color: "#12cdd4",
        id: "1jwkqg",
      },
      {
        color: "#2d9bf0",
        id: "2eqqks",
      },
      {
        color: "#414bb2",
        id: "mx3nuj",
      },
      {
        color: "#fac710",
        id: "out1aq",
      },
      {
        color: "#808080",
        id: "an3xrh",
      },
      {
        color: "#1a1a1a",
        id: "4nxq62",
      },
    ],
  },
  {
    id: "63ldtl",
    name: "Miro Brand Colors",
    _colors: [
      {
        color: "#ffd02f",
        id: "99d3ly",
      },
      {
        color: "#ffbfbf",
        id: "kxf9g4",
      },
      {
        color: "#ff6575",
        id: "rqrkj0",
      },
      {
        color: "#3f53d9",
        id: "lvfv2y",
      },
      {
        color: "#050038",
        id: "75bl5a",
      },
      {
        color: "#696688",
        id: "jo3vha",
      },
      {
        color: "#9B99AF",
        id: "5o1dnh",
      },
      {
        color: "#CDCCD7",
        id: "lo7vra",
      },
    ],
  },
]}
